import { useEffect, useState } from 'react';
import cfg from '../common/cfg';

let timeout: any;
export default function useResize(scale: number, baseWidth: number) {
  const [isLandscape, setIsLandscape] = useState(true);

  useEffect(() => {
    const calcLandscape = () => {
      const { clientHeight, clientWidth } = document.body;
      if (clientWidth / clientHeight < scale) {
        return true;
      }
      return false;
    };

    const onScreenSizeChange = () => {
      setIsLandscape(calcLandscape());

      const { clientHeight, clientWidth } = document.body;
      const $html = document.querySelector('html');
      if ($html) {
        if (calcLandscape()) {
          $html.style.fontSize = `${clientWidth / baseWidth}px`;
        } else {
          $html.style.fontSize = `${(clientHeight * scale) / baseWidth}px`;
        }
      }
    };

    const resizeFunc = () => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        onScreenSizeChange();
      }, 300);
    };

    onScreenSizeChange();

    window.addEventListener('resize', resizeFunc);

    return () => {
      window.removeEventListener('resize', resizeFunc);
    };
  }, [scale, baseWidth]);

  return [isLandscape];
}
